import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { accessAllowed } from '../services/subscriptionService';
import './GameCard.css';

const GameCard = ({ game, onGameClick }) => {
  const navigate = useNavigate();
  const [hasAccess] = useState(true);
  const [showPremiumTag] = useState(false);
  
  const handleCardClick = () => {
    if (hasAccess) {
      onGameClick(game.id);
    } else {
      navigate('/subscription');
    }
  };

  return (
    <div className="game-card" onClick={handleCardClick}>
      {showPremiumTag && <div className="game-card-overlay">🔒 Premium</div>}
      <h3>{game.title}</h3>
      <img src={game.thumbnail} alt={game.title} />
      <div className="game-description">
        <p>{game.description}</p>
      </div>
    </div>
  );
};

export default GameCard;
